import React, { useEffect, useState } from "react";
import { Modal } from "react-bootstrap";

const AddWorkingHrs = (props) => {
  const { showHide, handleShowHide, handleSelect, selectedObj } = props;

  const [hour, setHour] = useState("");
  const [minutes, setMinutes] = useState("");

  useEffect(() => {
    if (selectedObj?.title) {
      const wrkHr = selectedObj.title.toString().split(".");
      setHour(wrkHr[0] ?? "");
      setMinutes(wrkHr[1] ?? "");
    } else {
      setHour("");
      setMinutes("");
    }
  }, [selectedObj]);

  const formatDate = (date) => {
    if (!date) return "";
    const parsedDate = date instanceof Date ? date : new Date(date);
    if (!isNaN(parsedDate.getTime())) {
      return parsedDate.toLocaleDateString("en-US", {
        weekday: "long",
        day: "numeric",
        month: "long",
        year: "numeric",
      });
    }
    return "Invalid Date";
  };

  const doSubmit = () => {
    const hrNum = hour === "" ? 0 : Number(hour);
    const minStr = minutes === "" ? "0" : minutes.toString();
    let wrkHr;

    if (hrNum === 24) {
      wrkHr = "24.0";
    } else if (minStr && minStr !== "0") {
      wrkHr = `${hrNum}.${minStr}`;
    } else {
      wrkHr = hrNum;
    }

    handleSelect(wrkHr);
  };

  const hrNum = hour === "" ? 0 : Number(hour);
  const minNum = minutes === "" ? 0 : Number(minutes);

  const bothEmpty = hour === "" && minutes === "";
  const zeroZero = hrNum === 0 && minNum === 0;
  const outOfRange = hrNum < 0 || hrNum > 24 || minNum < 0 || minNum > 59;
  const twentyFourInvalid = hrNum === 24 && minNum !== 0;

  const isInvalid = bothEmpty || zeroZero || outOfRange || twentyFourInvalid;
  const summaryValue =
    hrNum === 24
      ? "24h 0m"
      : `${hour === "" ? 0 : hrNum}h ${minutes === "" ? 0 : minNum}m`;

  return (
    <>
      <style>{`
        /* Ensure the modal and backdrop are on top of other elements */
        .modal-backdrop {
          z-index: 1080 !important;
        }
        .modal {
          z-index: 1090 !important;
        }

        /* Glassmorphic backdrop filter and blur */
        .modal-backdrop.show {
          backdrop-filter: blur(8px) !important;
          -webkit-backdrop-filter: blur(8px) !important;
          background-color: rgba(15, 23, 42, 0.45) !important;
          opacity: 1 !important;
        }

        /* Spring-like transition for scale-in animation */
        .modal.fade .wf-hours-modal.modal-dialog {
          transform: scale(0.95) !important;
          transition: transform 0.3s cubic-bezier(0.34, 1.56, 0.64, 1) !important;
        }
        .modal.show .wf-hours-modal.modal-dialog {
          transform: scale(1) !important;
        }

        .wf-hours-modal {
          --task-accent: #2563eb; /* Primary Blue */
          --task-soft: #f8fafc;
          max-width: 760px !important;
          width: 100% !important;
        }

        .wf-hours-modal .modal-content {
          border-radius: 20px !important;
          border: 1px solid rgba(226, 232, 240, 0.8) !important;
          box-shadow: 0 24px 48px -12px rgba(15, 23, 42, 0.18) !important;
          overflow: hidden !important;
          background: #ffffff !important;
        }

        .wf-hours-modal .modal-header {
          position: relative !important;
          display: block !important;
          padding: 20px 28px !important;
          background: linear-gradient(180deg, #ffffff 0%, #f8fbff 100%) !important;
          border-bottom: 1px solid #edf2f7 !important;
          overflow: hidden !important;
        }

        .wf-hours-modal .modal-header::before {
          content: "" !important;
          position: absolute !important;
          top: 0 !important;
          left: 0 !important;
          bottom: 0 !important;
          width: 4px !important;
          background: var(--task-accent) !important;
        }

        .wf-hours-modal .rt-header-shell {
          display: flex !important;
          flex-direction: column !important;
          gap: 10px !important;
          width: 100% !important;
        }

        .wf-hours-modal .rt-header-top {
          display: flex !important;
          justify-content: space-between !important;
          align-items: flex-start !important;
          gap: 14px !important;
          width: 100% !important;
        }

        .wf-hours-modal .rt-header-main {
          display: flex !important;
          align-items: center !important;
          gap: 14px !important;
          min-width: 0 !important;
          flex: 1 1 auto !important;
        }

        .wf-hours-modal .rt-header-copy {
          display: flex !important;
          flex-direction: column !important;
          gap: 6px !important;
          min-width: 0 !important;
          padding-top: 4px !important;
        }

        .wf-hours-modal .rt-modal-title {
          display: inline-flex !important;
          align-items: center !important;
          margin: 0 !important;
          color: #0f172a !important;
          font-size: 18px !important;
          font-weight: 600 !important;
          line-height: 1.2 !important;
          min-width: 0 !important;
        }

        .wf-hours-modal .rt-header-icon {
          width: 52px !important;
          height: 52px !important;
          min-height: 52px !important;
          border-radius: 10px !important;
          display: inline-flex !important;
          align-items: center !important;
          justify-content: center !important;
          color: var(--task-accent) !important;
          background: #ffffff !important;
          border: 1px solid var(--task-accent) !important;
          box-shadow: 0 8px 18px -12px rgba(15,23,42,0.28) !important;
          font-size: 18px !important;
          flex-shrink: 0 !important;
        }

        .wf-hours-modal .rt-modal-title-text {
          display: inline-flex !important;
          align-items: center !important;
          gap: 12px !important;
          min-width: 0 !important;
          flex-wrap: wrap !important;
        }

        .wf-hours-modal .rt-modal-title-badge {
          display: inline-flex !important;
          align-items: center !important;
          justify-content: center !important;
          padding: 4px 10px !important;
          border-radius: 999px !important;
          font-size: 10px !important;
          font-weight: 600 !important;
          text-transform: uppercase !important;
          letter-spacing: 0.02em !important;
          background: var(--task-soft) !important;
          color: var(--task-accent) !important;
          border: 1px solid #e2e8f0 !important;
        }

        .wf-hours-modal .rt-modal-desc {
          display: inline-flex !important;
          align-items: center !important;
          gap: 6px !important;
          color: #64748b !important;
          font-weight: 600 !important;
          line-height: 1.4 !important;
          font-size: 12px !important;
        }
        .wf-hours-modal .rt-modal-desc i {
          color: var(--task-accent) !important;
        }

        .wf-hours-modal .modal-body {
          padding: 24px !important;
          background: #ffffff !important;
        }

        /* Premium Header Close Button */
        .wf-hours-modal .rt-action-btn {
          display: inline-flex !important;
          align-items: center !important;
          justify-content: center !important;
          width: 40px !important;
          height: 40px !important;
          padding: 0 !important;
          font-size: 12px !important;
          font-weight: 600 !important;
          color: #64748b !important;
          background: #ffffff !important;
          border: 1px solid #cbd5e1 !important;
          border-radius: 8px !important;
          cursor: pointer !important;
          transition: all 0.2s cubic-bezier(0.4, 0, 0.2, 1) !important;
          box-shadow: 0 1px 2px rgba(15, 23, 42, 0.05) !important;
          outline: none !important;
        }
        .wf-hours-modal .rt-action-btn:hover {
          color: #0f172a !important;
          border-color: #94a3b8 !important;
          background: #f8fafc !important;
          transform: translateY(-1px) !important;
          box-shadow: 0 4px 6px -1px rgba(0, 0, 0, 0.05) !important;
        }
        .wf-hours-modal .rt-action-btn:active {
          transform: translateY(0) !important;
        }
        .wf-hours-modal .rt-action-btn i {
          font-size: 11px !important;
          color: #94a3b8 !important;
          transition: color 0.2s ease !important;
        }
        .wf-hours-modal .rt-action-btn:hover i {
          color: #ef4444 !important;
        }

        /* Premium Modal Footer */
        .wf-hours-modal .modal-footer {
          background: #f8fafc !important;
          border-top: 1px solid #e2e8f0 !important;
          padding: 18px 28px !important;
          display: flex !important;
          justify-content: flex-end !important;
          gap: 12px !important;
        }

        .wf-hours-modal .wf-modal-footer-close-btn {
          display: inline-flex !important;
          align-items: center !important;
          gap: 7px !important;
          padding: 9px 20px !important;
          font-size: 13px !important;
          font-weight: 600 !important;
          color: #475569 !important;
          background: #ffffff !important;
          border: 1px solid #cbd5e1 !important;
          border-radius: 8px !important;
          box-shadow: 0 1px 2px rgba(15, 23, 42, 0.05) !important;
          outline: none !important;
          cursor: pointer !important;
          transition: all 0.2s cubic-bezier(0.4, 0, 0.2, 1) !important;
        }
        .wf-hours-modal .wf-modal-footer-close-btn:hover {
          background: #f8fafc !important;
          color: #0f172a !important;
          border-color: #94a3b8 !important;
          box-shadow: 0 4px 6px -1px rgba(0, 0, 0, 0.05) !important;
          transform: translateY(-1px) !important;
        }
        .wf-hours-modal .wf-modal-footer-close-btn:active {
          transform: translateY(0) !important;
        }
        .wf-hours-modal .wf-modal-footer-close-btn i {
          font-size: 12px !important;
          color: #64748b !important;
        }

        /* Action Buttons */
        .wf-hours-modal .wf-btn-save {
          display: inline-flex !important;
          align-items: center !important;
          justify-content: center !important;
          gap: 8px !important;
          height: 40px !important;
          padding: 0 20px !important;
          border-radius: 10px !important;
          border: 1px solid rgba(37, 99, 235, 0.15) !important;
          background: linear-gradient(135deg, #2563eb 0%, #1d4ed8 100%) !important;
          color: #ffffff !important;
          font-size: 13.5px !important;
          font-weight: 600 !important;
          cursor: pointer !important;
          transition: all 0.2s ease !important;
          outline: none !important;
          box-shadow: 0 4px 12px rgba(37, 99, 235, 0.15) !important;
        }

        .wf-hours-modal .wf-btn-save:hover:not(:disabled) {
          background: linear-gradient(135deg, #1d4ed8 0%, #1e40af 100%) !important;
          transform: translateY(-1px) !important;
          box-shadow: 0 6px 16px rgba(37, 99, 235, 0.2) !important;
        }

        .wf-hours-modal .wf-btn-save:active:not(:disabled) {
          transform: scale(0.97) !important;
        }

        .wf-hours-modal .wf-btn-save:disabled {
          opacity: 0.6 !important;
          cursor: not-allowed !important;
          box-shadow: none !important;
        }

        /* Body Custom Classes */
        .wf-hours-modal .wf-helper-card {
          border-radius: 16px;
          padding: 16px;
          background: linear-gradient(135deg, rgba(248, 250, 252, 0.98) 0%, rgba(239, 246, 255, 0.9) 100%);
          border: 1px solid rgba(191, 219, 254, 0.9);
          margin-bottom: 16px;
        }
        .wf-hours-modal .wf-helper-title {
          font-size: 14px;
          font-weight: 600;
          color: #0f172a;
          margin-bottom: 8px;
        }
        .wf-hours-modal .wf-helper-text {
          font-size: 12px;
          line-height: 1.7;
          color: #64748b;
          margin: 0;
        }
        .wf-hours-modal .wf-input-card {
          border-radius: 18px;
          border: 1px solid rgba(226, 232, 240, 1);
          background: #ffffff;
          box-shadow: 0 10px 22px rgba(15, 23, 42, 0.04);
          padding: 16px;
          height: 100%;
        }
        .wf-hours-modal .wf-input-label {
          font-size: 11px;
          font-weight: 600;
          letter-spacing: 0.08em;
          text-transform: uppercase;
          color: #64748b;
          margin-bottom: 8px;
        }
        .wf-hours-modal .wf-input-hint {
          font-size: 12px;
          color: #64748b;
          margin-bottom: 10px;
          line-height: 1.5;
        }
        .wf-hours-modal .wf-input-shell {
          border-radius: 14px;
          border: 1px solid rgba(226, 232, 240, 1) !important;
          background: #ffffff !important;
          box-shadow: inset 0 1px 2px rgba(15, 23, 42, 0.03) !important;
          min-height: 48px;
        }
        .wf-hours-modal .wf-summary-bar {
          margin-top: 16px;
          padding: 12px 14px;
          border-radius: 14px;
          background: #f8fafc;
          border: 1px solid rgba(226, 232, 240, 1);
          font-size: 13px;
          color: #334155;
          font-weight: 600;
        }
        .wf-hours-modal .wf-warning-bar {
          margin-top: 16px;
          padding: 12px 14px;
          border-radius: 14px;
          background: #fffbeb;
          border: 1px solid rgba(253, 230, 138, 1);
          font-size: 12px;
          line-height: 1.6;
          color: #92400e;
          font-weight: 600;
        }
      `}</style>
      <Modal
        show={showHide}
        dialogClassName="wf-hours-modal"
        centered
      >
        <Modal.Header>
          <div className="rt-header-shell">
            <div className="rt-header-top">
              <div className="rt-header-main">
                <i className="rt-header-icon fa fa-clock-o" aria-hidden="true" />
                <div className="rt-header-copy">
                  <h2 className="rt-modal-title">
                    <span className="rt-modal-title-text">
                      <span>Add/Edit Hours and Minutes</span>
                      <span className="rt-modal-title-badge">Entry</span>
                    </span>
                  </h2>
                  <span className="rt-modal-desc">
                    <i className="fa fa-calendar-o" aria-hidden="true" /> {formatDate(selectedObj?.start)}
                  </span>
                </div>
              </div>
              <button
                type="button"
                className="rt-action-btn"
                onClick={() => handleShowHide("")}
                aria-label="Close working hours popup"
              >
                <i className="fa fa-times" aria-hidden="true" />
              </button>
            </div>
          </div>
        </Modal.Header>

        <Modal.Body>
          <div className="wf-helper-card">
            <div className="wf-helper-title">Quick tip</div>
            <p className="wf-helper-text">
              Use hours and minutes for the selected day. If you enter `24` hours,
              minutes are locked to `0` automatically.
            </p>
          </div>
          <div className="row">
            <div className="col-md-6">
              <div className="wf-input-card">
                <label htmlFor="hour" className="wf-input-label">
                  Enter Hour
                </label>
                <div className="wf-input-hint">
                  Allowed range is 0 to 24 hours.
                </div>
                <input
                  type="number"
                  id="hour"
                  name="hour"
                  className="form-control wf-input-shell"
                  placeholder="Enter Hour"
                  value={hour}
                  onChange={({ currentTarget }) => {
                    let val = currentTarget.value;
                    if (val === "") {
                      setHour("");
                      return;
                    }
                    const n = Number(val);
                    if (isNaN(n)) return;
                    if (n < 0) val = "0";
                    if (n > 24) val = "24";
                    setHour(val);
                    if (val === "24") {
                      setMinutes("0");
                    }
                  }}
                />
              </div>
            </div>

            <div className="col-md-6">
              <div className="wf-input-card">
                <label
                  htmlFor="minutes"
                  className="wf-input-label"
                >
                  Enter Minutes
                </label>
                <div className="wf-input-hint">
                  Allowed range is 0 to 59 minutes.
                </div>
                <input
                  type="number"
                  id="minutes"
                  name="minutes"
                  className="form-control wf-input-shell"
                  placeholder="Enter Minutes"
                  value={hour === "24" ? "0" : minutes}
                  disabled={hour === "24"}
                  onChange={({ currentTarget }) => {
                    let val = currentTarget.value;
                    if (val === "") {
                      setMinutes("");
                      return;
                    }
                    const n = Number(val);
                    if (isNaN(n)) return;
                    if (n < 0) val = "0";
                    if (n > 59) val = "59";
                    setMinutes(val);
                  }}
                />
              </div>
            </div>
          </div>

          <div className="wf-summary-bar">
            Selected duration: {summaryValue}
          </div>
          {isInvalid && (
            <div className="wf-warning-bar">
              Enter a valid time greater than `0h 0m`. Minutes must stay between
              `0-59`, and `24` hours only works with `0` minutes.
            </div>
          )}
        </Modal.Body>

        <Modal.Footer>
          <button
            type="button"
            className="wf-modal-footer-close-btn"
            onClick={() => handleShowHide("")}
          >
            <i className="fa fa-times" aria-hidden="true"></i> Cancel
          </button>
          <button
            type="button"
            className="wf-btn-save"
            disabled={isInvalid}
            onClick={doSubmit}
          >
            <i className="fa fa-check" aria-hidden="true"></i> Save
          </button>
        </Modal.Footer>
      </Modal>
    </>
  );
};

export default AddWorkingHrs;
